// Return a random base-36 uid, optionally postfixed with a key.
// Example:
//  uid() === 'e4t81q'
//  uid('MyComponent') === 'acta01-MyComponent'

const uid = (key?: string, length: number = 6): string =>
  [
    Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))
      .toString(36)
      .slice(1),
    key ? `-${key}` : '',
  ].join('');

export default uid;
